define('directives/myservices/serviceMark/serviceMark.directives',['app','mainCons'], function (app, mainCons) {
    app.directive('serviceMark', ['OpenApp','OpenOther','UserInfo','$filter','$state','$stateParams','OpenFeedBack',function (OpenApp,OpenOther,UserInfo,$filter,$state,$stateParams,OpenFeedBack) {
        var timeout;
        return {
            restrict: 'E',
            replace: true,
            require: "?ngModel",
            scope:{
                isOnShelf:"="
            },
            templateUrl: 'directives/myservices/serviceMark/serviceMark.template.html',
            link: function ($scope, $element, attrs,ngModelCtrl) {
                var isOnshelf = $scope.isOnShelf;//1 上架 2 升级
                var serviceItem = $stateParams.serviceItem;
                if(serviceItem == undefined &&  isOnshelf)
                {
                    var temp = isOnshelf.split('|');
                    isOnshelf = temp[0];
                    serviceItem = temp[1];
                }

                $scope.maxNumError = "";
                $scope.mark = mark;
                var flag = false;
                angular.element('.good-gray').on('click',function(){
                    flag = true ;
                    angular.element('.good-gray').prev('img').toggleClass('hidden');
                    angular.element('.good-gray').toggleClass('hidden');
                    angular.element('.bad-gray').removeClass('cursor-pointer');
                    angular.element('.bad-gray').off();
                });

                angular.element('.bad-gray').on('click',function(){
                    flag = true ;
                    angular.element('.bad-gray').prev('img').toggleClass('hidden');
                    angular.element('.bad-gray').toggleClass('hidden');
                    angular.element('.good-gray').removeClass('cursor-pointer');
                    angular.element('.good-gray').off();
                });

                function mark(score){
                    if(!flag){
                        //1、数量加1

                        //2、调接口
                        var params = {
                            req: {
                                score:score,
                                objectID: serviceItem,
                                objectType:2,
                                orderID:isOnshelf?isOnshelf:1
                            }
                        };
                        OpenFeedBack.submitFeedback(params).then(function(res){
                        }).catch(function(res){
                            if (res && res.NSP_STATUS && res.NSP_STATUS==90820002 ) {
                                $scope.maxNumError = "今日评价次数已达上限，感谢使用。";
                            }
                        });
                    }
                }

            }
        }
    }]);
});
